export const GAD = 
{
    Metadata:{Name:'GAD-7',maxColumn:4,numRows:8},
    Sections:
    [
        {
            Headers:[
                "<span class='importantText'>Over the last 2 weeks</span> how often have you been bothered by the following problems",
                "Not at all",
                "Several Days",
                "More then half the days",
                "Nearly every day"
            ],
            Questions:[
                {
                    Prompt:"1. Feeling nervous, anxious or on edge",
                    Responses:[
                        {Value:0,Type:"radio"},
                        {Value:1,Type:"radio"},
                        {Value:2,Type:"radio"},
                        {Value:3,Type:"radio"}
                    ]
                },
                {
                    Prompt:"2. Not being able to stop or control worrying",
                    Responses:[
                        {Value:0,Type:"radio"},
                        {Value:1,Type:"radio"},
                        {Value:2,Type:"radio"},
                        {Value:3,Type:"radio"}
                    ]
                },
                {
                    Prompt:"3. Worrying too much about different things",
                    Responses:[
                        {Value:0,Type:"radio"},
                        {Value:1,Type:"radio"},
                        {Value:2,Type:"radio"},
                        {Value:3,Type:"radio"}
                    ]
                },
                {
                    Prompt:"4. Trouble relaxing",
                    Responses:[
                        {Value:0,Type:"radio"},
                        {Value:1,Type:"radio"},
                        {Value:2,Type:"radio"},
                        {Value:3,Type:"radio"}
                    ]
                },
                {
                    Prompt:"5. Being so restless that it is hard to sit still",
                    Responses:[
                        {Value:0,Type:"radio"},
                        {Value:1,Type:"radio"},
                        {Value:2,Type:"radio"},
                        {Value:3,Type:"radio"}
                    ]
                },
                {
                    Prompt:"6. Becoming easily annoyed or irritable.",
                    Responses:[
                        {Value:0,Type:"radio"},
                        {Value:1,Type:"radio"},
                        {Value:2,Type:"radio"},
                        {Value:3,Type:"radio"}
                    ]
                },
                {
                    Prompt:"7. Feeling afraid as if something awful might happen",
                    Responses:[
                        {Value:0,Type:"radio"},
                        {Value:1,Type:"radio"},
                        {Value:2,Type:"radio"},
                        {Value:3,Type:"radio"}
                    ]
                },
            ]
        },
        {
            Headers:[
                "",
                "Not Difficult at all",
                "Somewhat Difficult",
                "Very Difficult",
                "Extremely Difficult"
            ],
            Questions:[
                {
                    Prompt:"If any of the above problems were identified, how difficult have these made it for you to do your work, take care of things at home, or get along with other people?",
                    Responses:[
                        {Value:0,Type:"radio"},
                        {Value:0,Type:"radio"},
                        {Value:0,Type:"radio"},
                        {Value:0,Type:"radio"}
                    ]
                },
            ]
        }
    ]
}